import { TFontSizes } from '@mofid-securities/uikit';
import { semanticColorsConfig } from 'configs/tailwind/color';
import { extendTailwindMerge } from 'tailwind-merge';
import { TColor } from '@/types/color';
import { isValidHexColor } from './function';

type TColorObject = {
  [category: string]: {
    [colorName: string]: string;
  };
};

const currentConfig = require('@/root/tailwind.config');
const defaultConfig = require('tailwindcss/defaultConfig');
const resolveConfig = require('tailwindcss/resolveConfig');

export type TailwindConfig = typeof defaultConfig & typeof currentConfig;
const tailwindConfig: TailwindConfig = resolveConfig(currentConfig);

export default tailwindConfig;

export const setFontSize = (fontSize: TFontSizes | number) => {
  if (typeof fontSize === 'number') {
    return `text-[${fontSize}px`;
  }
  if (typeof fontSize === 'string') {
    return `text-${fontSize}`;
  }
};

const getDynamicColorsList = (colorObject: TColorObject) => {
  return Object.values(colorObject).flatMap(Object.keys);
};

export const customTwMerge = extendTailwindMerge({
  override: {
    classGroups: {
      'text-color': getDynamicColorsList(semanticColorsConfig!),
    },
  },
});

export const setColor = (color?: TColor | string) => {
  if (!color) {
    return '';
  }
  if (isValidHexColor(color)) {
    return color;
  }
  if (color.includes('-')) {
    const colorArray = color.split('-');
    if (colorArray.length === 2) {
      const colorName = colorArray[0];
      const colorShade = colorArray[1];
      // Safely check if colorName exists in tailwindConfig.theme.colors
      if (
        tailwindConfig.theme.colors[colorName] &&
        typeof tailwindConfig.theme.colors[colorName] === 'object'
      ) {
        const colorGroup = tailwindConfig.theme.colors[colorName];
        // Safely check if colorShade exists in the colorGroup
        if (colorShade in colorGroup) {
          return colorGroup[colorShade];
        }
      }
    }
  }
  return color;
};

// https://github.com/dcastil/tailwind-merge/blob/v2.3.0/docs/configuration.md
// A custom twMerge function is necessary to handle our custom classes.
// twMerge is designed to work with Tailwind's default utility classes, but it cannot recognize custom ones.
// For example, when merging `twMerge('text-highcontrast-filled-primary-enabled text-xxs')`, it would remove 'text-highcontrast-filled-primary-enabled'
// because it's not a recognized Tailwind color, leaving only 'text-xs'.
// To prevent this from happening, we need to inform twMerge about our custom classes so they aren't removed
// when merged with default Tailwind classes. Please refer to the test file for more details on the implementation.
